/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    if (! comparing) {
      var res = '<span class="grid-product__price--regular">' + formatPrice(price) + '</span>';
    }
    if (comparing) {
      var res = '<span class="grid-product__price--regular price--sale">' + formatPrice(price) + '</span>'
      res += ' <span class="ais-hit--price-striked grid-product__price--original"><span>' + formatPrice(compare_at_price) + '</span></span> ';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return(unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(text, render) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    infoField: function infoField() {
      let title = this.title;
      let titleHandle = title.toLowerCase().replace(/ /g, '-');
      let handle = this.handle;
      let secondaryTitle = handle.replace(titleHandle + '-', '');
      let replaceComma = secondaryTitle.replace(/(\d)-(\d)/g, '$1,$2');
      let infoField = replaceComma.replace(/-/g, ' ');
      return '<div class="grid-product__extension">' + infoField[0].toUpperCase() + infoField.slice(1).toLowerCase() + '</div>';
    },
    outOfStockBadge: function outOfStockBadge() {
      if (this.inventory_available === false && this.can_order !== true) {
        return '<div class="badge badge--sold-out"> Sold Out</div>';
      } else {
        return;
      }
    },
    onSaleBadge: function onSaleBadge() {
      if (this.price<this.compare_at_price){
        return '<div class="badge badge--sale">Sale</div>';
      } else {
        return;
      }
    }, newItemBadge: function newItemBadge(){
      if (typeof this.named_tags['Merkintä'] !== 'undefined' && this.named_tags['Merkintä'].includes('Uutuus') && this.inventory_available !== false || 
      typeof this.named_tags['Label'] !== 'undefined' && this.named_tags['Label'].includes('New') && this.inventory_available !== false) {
        return '<div class="badge badge--new">New</div>';
      }
      else {
        return;
      }
    },
    storeBadge: function storeBadge(){
      if (typeof this.named_tags['Merkintä'] !== 'undefined' && this.named_tags['Merkintä'].includes('Store') && this.inventory_available !== false ||
      typeof this.named_tags['Label'] !== 'undefined' && this.named_tags['Label'].includes('Outlet') && this.inventory_available !== false) {
          return '<div class="badge badge--store">Translation missing: en.products.product.store_only</div>';
      } else {
        return;
      }
    },
    outletBadge: function outletBadge(){
      if (typeof this.named_tags['Merkintä'] !== 'undefined' && this.named_tags['Merkintä'].includes('Outlet') && this.inventory_available !== false ||
      typeof this.named_tags['Label'] !== 'undefined' && this.named_tags['Label'].includes('Outlet') && this.inventory_available !== false) {
          return '<div class="badge badge--outlet">Laebl:Outlet</div>';
      } else {
        return;
      }
    }, friendPrice: function friendPrice() {
      var tags = this.tags;
      var friendTags = tags.filter(function (t) { return t.toLowerCase().includes('_friends') }); // return array
      if (friendTags.length> 0) {
        var friend_price = (parseFloat(friendTags[0].split('|').pop()) * 1);
        return '<span class="friends-price price--sale medium-down--hide">' + theme.strings.friendsPrice + ' ' + formatPrice(friend_price) + '</span>';
      };
    },
    friendPriceMobile: function friendPriceMobile() {
      var tags = this.tags;
      var friendTags = tags.filter(function (t) { return t.toLowerCase().includes('_friends') }); // return array
      if (friendTags.length> 0) {
        var friend_price = (parseFloat(friendTags[0].split('|').pop()) * 1);
        return '<span class="friends-price price--sale friends-price medium-up--hide">' + theme.strings.friendsPrice + ' ' + formatPrice(friend_price) + '</span>';
      };
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, this.compare_at_price, this.price_ratio);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, this.compare_at_price, this.price_ratio);
    },
    instantSearchAddToCart: function instantSearchAddToCart() {
      const btnText = this.inventory_available !== false ? "Add to cart" : "Sold Out"
      return `<form method="post" action="/cart/add" id="AddToCartForm-template--${this.objectID}" accept-charset="UTF-8" class="product-single__form" enctype="multipart/form-data">
                <input type="hidden" name="form_type" value="product">
                <select name="id" id="ProductSelect-${this.objectID}" class="product-single__variants no-js">
                  <option selected="selected" value="${this.objectID}">
                  </option>
                </select>
              <button type="submit" name="add" data-add-to-cart="" class="btn btn--full add-to-cart">
                <span data-add-to-cart-text="" data-default-text="${btnText}">
                  ${btnText}
                </span>
              </button>
              </form>`
    },
    instantSearchSavings: function instantSearchSavings() {
      var comparing = Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price);
      if (!comparing) return;
      var discount_ratio = 1.0 - this.price_ratio;
      var res = '<span class="grid-product__price--savings">- ' + Math.round(discount_ratio * 100) + '%</span>';
      return res;
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return('/products/' + this.handle + (
        addVariantId
          ? '?variant=' + this.objectID
          : ''
      ));
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(this._highlightResult.title.value);
      }

      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html').documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(this._highlightResult.title.value);
      }

      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (this._highlightResult.product_type && this._highlightResult.product_type.value) {
        return algolia.helpers.fullEscapedAttribute(this._highlightResult.product_type.value);
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(this._highlightResult.vendor.value);
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct
        ? this.product_image
        : this.image;
      if (! image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
  };



  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct
          ? this.product_image
          : this.image;

        if (! image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

/* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) 
    helpersArray[i] = [
      helpersNames[i],
      helpers[helpersNames[i]]
    ];
  

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
